import React from 'react';

import { Icon, PressableProps } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text/Typography';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { IconContainer, StyledPressable } from './loyalty-promo-code-cta.styled';

export const LoyaltyPromoCodeCTA = ({ onPress }: PressableProps) => {
  return (
    <StyledPressable onPress={onPress}>
      <IconContainer>
        <Icon variant="offer" color={primitive.$white} {...hiddenAccessibilityPlatformProps} />
      </IconContainer>
      <Typography bold>{t('promoCodeCTA')}</Typography>
    </StyledPressable>
  );
};
